module.exports = __webpack_public_path__ + "img/cancel-reservation.971f6359.svg";